import FormattedMessage from 'I18n/components/FormattedMessage';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UIConfirmModal from 'UIComponents/dialog/UIConfirmModal';
import { jsx as _jsx } from "react/jsx-runtime";
const InvoiceVoidModal = props => {
  const {
    onConfirm,
    onReject,
    voidInProgress
  } = props;
  const title = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "invoicesHighlightCard.modals.void.title"
  });
  const description = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "invoicesHighlightCard.modals.void.description"
  });
  const confirmLabel = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "invoicesHighlightCard.modals.void.confirm"
  });
  const rejectLabel = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "invoicesHighlightCard.modals.void.reject"
  });
  return /*#__PURE__*/_jsx(UIConfirmModal, {
    "data-test-id": "invoice-void-modal",
    size: "auto",
    message: title,
    description: description,
    confirmLabel: confirmLabel,
    rejectLabel: rejectLabel,
    confirmButtonProps: {
      loading: voidInProgress
    },
    ConfirmButton: UILoadingButton,
    onConfirm: onConfirm,
    onReject: onReject
  });
};
export default InvoiceVoidModal;